import Property from 'app/shared/model/Property';
import KeyPager from 'app/shared/model/KeyPager';
import PaidInclusionReleaseDate from 'app/shared/model/PaidInclusionReleaseDate';

const Properties = ({
    numTotalListings = 0,
    numActiveListings = 0,
    numInactiveListings = 0,
    isPartialResponse = false,
    listings = [],
    maintenancePartner = {},
    paidInclusionReleaseDates = [],
    pager = {},
} = {}) => ({
    numTotalListings: Number(numTotalListings),
    numActiveListings: Number(numActiveListings),
    numInactiveListings: Number(numInactiveListings),
    isPartialResponse: Boolean(isPartialResponse),
    listings: listings.map(item => Property(item)),
    maintenancePartner: Object(maintenancePartner),
    paidInclusionReleaseDates: paidInclusionReleaseDates.map(item => PaidInclusionReleaseDate(item)),
    pager: KeyPager(pager),
});

export default Properties;
